import useTypedSelector from '../../../../../../common/useTypedSelector';
import {SceneKey, TalkGroupKey} from '../type/KeyType.type';
import {ViewingMode} from '../type/ViewingMode.enum';
import {ZIndex} from '../type/ZIndex.enum';
import {getDataUrlOrUrl} from '../util/getDataUrlOrUrl';
import {TalkViewerBackgroundContainer} from './TalkViewerBackgroundContainer';
import {TalkViewerTalkListContainer} from './TalkViewerTalkListContainer';

interface TalkViewerGroupContainerProps {
  talkGroupId: TalkGroupKey;
  sceneId: SceneKey;
}

export function TalkViewerGroupContainer({
  talkGroupId,
  sceneId,
}: TalkViewerGroupContainerProps) {
  const {viewingMode, talkGroup, preloadedMedia} = useTypedSelector(state => ({
    viewingMode: state.talkViewer.settings.viewingMode,
    talkGroup: state.talkViewer.talkGroupMap[talkGroupId],
    preloadedMedia: state.talkViewer.preloadedMedia,
  }));
  if (!talkGroup) {
    return null;
  }
  const {floatingImage, floatingImageOpacity} = talkGroup;
  return (
    <div className="flex flex-col">
      <TalkViewerBackgroundContainer talkGroupId={talkGroupId} />
      {viewingMode !== ViewingMode.Scroll && (
        <img
          className="pointer-events-none fixed top-0 left-0 w-full opacity-0 transition-none"
          style={{
            zIndex: ZIndex.FloatingImage,
            transition: floatingImage ? 'opacity 2s' : undefined,
            opacity: floatingImage ? floatingImageOpacity : undefined,
          }}
          src={
            floatingImage
              ? getDataUrlOrUrl(floatingImage, preloadedMedia)
              : undefined
          }
          alt="전경 이미지"
        />
      )}
      <TalkViewerTalkListContainer sceneId={sceneId} />
    </div>
  );
}
